"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var TxtCardComponent = function TxtCardComponent(props) {
  var flexTitle = props.flexTitle,
      _a = props.configuration,
      configuration = _a === void 0 ? [] : _a,
      desc = props.desc,
      flexSmallTitle = props.flexSmallTitle,
      mergeComponentStatus = props.mergeComponentStatus;

  var _b = (0, _react.useState)({}),
      styles = _b[0],
      setStyls = _b[1];

  var _c = (0, _react.useState)(0),
      value = _c[0],
      setValue = _c[1];

  var _d = (0, _react.useState)(0),
      ifshow = _d[0],
      setIfshow = _d[1];

  var compatibleArr = configuration && configuration.length % 4 ? __spreadArrays(configuration, new Array(4 - configuration.length % 4).fill({
    supplement: true
  })) : configuration;
  (0, _react.useEffect)(function () {
    var collectStyles = {};

    if (configuration.length > 8) {
      setIfshow(1);
      collectStyles = {
        width: '100%',
        maxHeight: '216px'
      };
    } else {
      collectStyles = {
        maxHeight: '2200px',
        width: '100%'
      };
    }

    setStyls(collectStyles);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "best-practices-txtcard-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "best-practices-txtcard-wrap"
  }, (flexTitle || desc || flexSmallTitle) && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "best-practices-txtcard-list",
    style: __assign(__assign({}, styles), {
      overflow: 'hidden'
    })
  }, compatibleArr.map(function (item, index) {
    var title = item.title,
        description = item.description,
        supplement = item.supplement,
        href = item.href,
        extendProps = item.extendProps;
    return /*#__PURE__*/_react["default"].createElement("a", __assign({
      key: index,
      className: (0, _classnames["default"])('best-practices-txtcard-item', {
        supplement: supplement
      }),
      href: href ? href : 'javascript:void(0);'
    }, extendProps || {}), /*#__PURE__*/_react["default"].createElement("header", {
      className: "best-practices-txtcard-item-title"
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "best-practices-txtcard-item-desc"
    }, description));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: ifshow === 1 ? {
      display: 'flex'
    } : {
      display: 'none'
    },
    className: value === 1 ? 'txtcard-posi-open txtcard-posi' : 'txtcard-posi-stop txtcard-posi',
    onClick: function onClick() {
      var collectStyles;

      if (value === 0) {
        if (configuration.length > 8 && configuration.length <= 12) {
          collectStyles = {
            width: '100%',
            maxHeight: '330px'
          };
        } else if (configuration.length > 12 && configuration.length <= 16) {
          collectStyles = {
            width: '100%',
            maxHeight: '440px'
          };
        } else {
          collectStyles = {
            width: '100%',
            maxHeight: '2200px'
          };
        }

        setStyls(collectStyles);
        setValue(1);
      } else {
        collectStyles = {
          width: '100%',
          maxHeight: '216px'
        };
        setStyls(collectStyles);
        setValue(0);
      }
    }
  }, value === 0 ? 'Show more' : 'Show less', /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont d-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#006EFF",
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  })))));
};

var txtCard = function txtCard(props) {
  var paddingTopNum = props.paddingTopNum,
      paddingBottomNum = props.paddingBottomNum,
      flexTitle = props.flexTitle,
      style = props.style,
      isFooterPart = props.isFooterPart,
      isCombination = props.isCombination;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(TxtCardComponent, __assign({}, props)));
};

var _default = txtCard;
exports["default"] = _default;